import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Link2release extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
   
    //this.props.getuser(this.props.match.params[0]);
 
    this.props.getQuotbypo(this.props.match.params.id);
    this.props.gotopage();
  }

  

  render() {
    // return <div>{new Date()}</div>;
    return null;
  }
}

Link2release.propTypes = {
  gotopage: PropTypes.func.isRequired,
  reference_id: PropTypes.string
};

export default Link2release;



// WEBPACK FOOTER //
// ./src/components/views/Link2release/index.js